import { Suspense } from "react";
import { createBrowserRouter, Outlet } from "react-router-dom";

import {
  AIProgressDataWrapper,
  AuthDataWrapper,
  BusinessUnitDataWrapper,
  LayoutDataWrapper,
  PendingEODDataWrapper,
  PersonalDataWrapper,
} from "components/DataWrapper";
import { ErrorWrapper } from "components/Error";
import Layout from "components/Layout";
import PageLoader from "components/Layout/PageLoader";
import {
  AccessRoute,
  AuthRoute,
  LayoutRoute,
  RedirectRoute,
} from "components/Route";
import { routes } from "./routes";

const MainElement = () => {
  return (
    <ErrorWrapper fullPage>
      <LayoutDataWrapper>
        <AuthDataWrapper>
          <Layout>
            <BusinessUnitDataWrapper>
              <AIProgressDataWrapper>
                <PersonalDataWrapper>
                  <PendingEODDataWrapper>
                    <Suspense fallback={<PageLoader />}>
                      <Outlet />
                    </Suspense>
                  </PendingEODDataWrapper>
                </PersonalDataWrapper>
              </AIProgressDataWrapper>
            </BusinessUnitDataWrapper>
          </Layout>
        </AuthDataWrapper>
      </LayoutDataWrapper>
    </ErrorWrapper>
  );
};

const router = createBrowserRouter([
  {
    element: <MainElement />,
    children: routes.map((route) => ({
      path: route.path,
      element: (
        <LayoutRoute route={route}>
          <RedirectRoute route={route}>
            <AuthRoute route={route}>
              <AccessRoute route={route}>{route.element}</AccessRoute>
            </AuthRoute>
          </RedirectRoute>
        </LayoutRoute>
      ),
    })),
  },
]);

export default router;
